<template>
  <el-dialog title="选择活动" :visible.sync="dialogVisible" width="25%" @close="$emit('update:visible',false)">
    <div class="weui-cell mb15 pl0 pr0">
      <div class="weui-cell__bd"><span v-if="type==0" class="gray999">可选择指定活动及活动套餐类型</span></div>
      <div class="weui-cell__ft">
        <el-button type="primary" :disabled="checkList.length>0?false:true" @click="confirmSelect" size="small">确定选择</el-button>
      </div>
    </div>  
    <el-table :inline="true" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column width="55" type="selection"></el-table-column>
      <el-table-column prop="activity_title" label="活动名称"></el-table-column>
      <el-table-column label="是否有活动价格套餐" v-if="type==0">
        <template slot-scope="scope">
          <p v-if="scope.row.sku_list.length >0 ">有</p>
          <p v-else> 无</p>
        </template>
      </el-table-column>
    </el-table>  
    <div class="pag_wrap" style="margin-top: 15px">
      <el-pagination
        background
        :page-size="page.page_size"
        :current-page="page.current_page"
        layout="total, prev, pager, next"
        :total="page.total_rows"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div> 
  </el-dialog>  
</template>

<script>
import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: 'merchantDialog',
  props: ['visible','type'], // type => 0-联盟商家 1-特权折扣
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      checkList: [],
      page: {
        current_page: pagination.current_page,
        page_size: pagination.page_size,
        total_rows: pagination.total_rows
      },
      listData: {
        title: '',
        tmp_id: '',
        status: '',
        process_status: '',
        start_time: '',
        end_time: '',
        check_status: '',
        page: 1
      }
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      if (this.visible) {
        this.listData.page = 1;
        this.initFn();
      }
    }
  },
  methods: {
    initFn() {
      this.axios
        .post(api.activityListEasy, this.listData)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result;
            response.data.page.current_page = parseInt(response.data.page.current_page);
            this.page = response.data.page;            
          } 
        }).catch(() => {})
    },
    // 分页
    pageIndexChange(pageindex) {
      this.listData.page = pageindex;
      this.initFn();
    },
    handleSelectionChange(val) {
      this.checkList = val;
    },
    confirmSelect() {
      let obj = [];
      
      for (let i = 0; i < this.checkList.length; i++) {
        obj.push(this.checkList[i]);
      }
      
      this.$emit('updatePageInfo', obj);
      this.$emit('update:visible', false);
    }
  }
}
</script>